import { EduHubTagResult } from 'types/studio/eduHub';
import { Typography } from '@ag1/ui';
import { routes } from '@portal/constants/routes';
import { NavLinkButton } from '../../../components/NavLinkButton';
import styles from './EduArticleTags.module.scss';

interface Props {
  tags: EduHubTagResult[];
}

export const EduArticleTags = ({ tags }: Props) => {
  const { eduHubTag } = routes;
  return (
    <section className={styles.root}>
      <div className={styles.content}>
        <Typography
          variant="headline"
          size="2"
          component="h2"
          noPadding
          color="black-new"
          className={styles.title}>
          Read more about
        </Typography>
        <ul className={styles.list}>
          {tags.map(({ title, slug }) => (
            <li className={styles.item} key={slug.current}>
              <NavLinkButton href={eduHubTag({ slug: slug.current })} className={styles.tag}>
                {title}
              </NavLinkButton>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
